const MS_PER_SECOND = 1_000;
const MS_PER_MINUTE = 60_000;
const ONE_MINUTE_SECONDS = 60;

export const formatDuration = (ms: number): string => {
  const seconds = Math.round(ms / MS_PER_SECOND);

  if (seconds < ONE_MINUTE_SECONDS) {
    return `${seconds}s`;
  }

  return `${Math.round(ms / MS_PER_MINUTE)}m`;
};
